import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { UniversalLink } from '@plone/volto/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { Accordion, Icon } from 'semantic-ui-react';

const AccordionListing = ({ items, linkTitle, linkHref, isEditMode, blockTitle }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleClick = (e, titleProps) => {
    const { index } = titleProps;
    setActiveIndex((prev) => (prev === index ? -1 : index));
  };

  const link = linkHref;

  return (
    <div className='accordion-block '>
      {blockTitle && <h3 className="cardLinks__title mt-0">{blockTitle}</h3>}

      {items.length > 0 && (
        <Accordion>
          {items.map((item, index) => (
            <React.Fragment key={item['@id']}>
              <Accordion.Title
                id={'accordionTitle-' + index}
                role="button"
                tabindex="0"
                aria-controls={'accordionContent-' + index}
                active={activeIndex === index}
                index={index}
                onClick={handleClick}
                aria-expanded={activeIndex === index}
              >
                <Icon name='dropdown' />
                {item.title || item.id}
              </Accordion.Title>

              {item?.description && (
                <Accordion.Content
                  id={'accordionContent-' + index}
                  role="region"
                  aria-labelledby={'accordionTitle-' + index}
                  active={activeIndex === index}>
                  <p className='px-4 py-2 mb-0'>
                    {item.description}
                  </p>
                </Accordion.Content>
              )}
            </React.Fragment>
          ))}
        </Accordion>
      )}

      {link && (
        <p className="readMoreItem mb-4 d-print-none pt-1 text-end">
          <UniversalLink
            href={link}
            className="readMoreItem__btn ui button primary"
          >
            {linkTitle ? (
              <span>{linkTitle}</span>
            ) : (
              <FormattedMessage id="See all" defaultMessage="See all" />
            )}
            <span>{blockTitle}</span>
            <FontAwesomeIcon
              icon={faChevronRight}
              className="readMoreItem__icon ms-3"
            />
          </UniversalLink>
        </p>
      )}
    </div>
  );
};

AccordionListing.propTypes = {
  linkHref: PropTypes.any,
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  isEditMode: PropTypes.bool,
  blockTitle: PropTypes.string,
};

export default AccordionListing;
